<template>
  <div @mouseleave="mouseLeave">
    <div
      :class="['overlay-list', { opened: canOpenOverlayList }]"
      v-if="overlayList"
    >
      <DCardOverlayList
        :data="overlayList"
        :hashId="hashId"
        :apiBaseUrl="apiBaseUrl"
        :cid="cid"
        :company-source="companySource"
        @close="openOverlayList"
        @date-selected="$emit('date-selected', $event)"
        v-if="canOpenOverlayList"
      />
    </div>

    <div @click="click" v-if="human_filters && human_filters.score">
      <DHumanFiltersOverlay :human_filters="human_filters" />
    </div>

    <div @click="click" class="dcard-action-overlay">
      <q-toolbar class="bottom-toolbar">
        <q-btn
          v-if="showsEnterSection"
          @click="enterSectionClicked"
          class="q-pr-sm prevent bg-white test"
          text-color="secondary"
          no-caps
          dense
          icon="north_east"
          label="Enter Section"
          data-prevent="true"
          :loading="loading"
          aria-label="enter-section-btn"
        >
          <template #loading>
            <q-spinner-dots size="sm" color="secondary" />
          </template>
        </q-btn>

        <template v-if="overlayList || overlayTitle">
          <q-space />

          <div class="column items-end justify-start">
            <div
              :class="[
                'text-white text-uppercase font-weight-bold overlay-title',
                { 'q-mb-sm': overlayList },
              ]"
              v-if="overlayTitle"
            >
              {{ overlayTitle }}
            </div>

            <q-btn
              data-prevent="true"
              @click="openOverlayList"
              class="q-pr-sm prevent bg-white"
              text-color="secondary"
              no-caps
              dense
              :icon="overlayBtnIcon"
              :label="overlayBtnLabel"
              v-if="overlayList"
            />
          </div>
        </template>

        <!-- <q-btn
          @click.stop="moreClicked"
          icon="more_horiz"
          dense
          color="secondary"
        >
        </q-btn>
        <div ref="moreButtonTarget"></div> -->
      </q-toolbar>
    </div>
    <q-menu
      :no-parent-event="true"
      content-class="shadow-10"
      content-style="border-radius:2px"
      @mouseenter="menuMouseEnter"
      :target="$refs.moreButtonTarget"
      v-model="showMenu"
      :persistent="true"
      :auto-close="false"
      anchor="top right"
      self="center left"
    >
      <q-list separator>
        <q-item @click="click" v-ripple clickable>
          <q-item-section class="q-pl-md" thumbnail>
            <q-icon color="secondary" name="remove_red_eye"></q-icon>
          </q-item-section>
          <q-item-section> Preview card info </q-item-section>
        </q-item>
        <q-item
          @click="enterSectionClicked"
          v-if="showsEnterSection"
          v-ripple
          clickable
        >
          <q-item-section class="q-pl-md" thumbnail>
            <q-icon color="secondary" name="north_east"></q-icon>
          </q-item-section>
          <q-item-section> Enter section </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>
<script>
import DCardOverlayList from "./DCardOverlayList.vue";
import DHumanFiltersOverlay from "../DCard/components/DHumanFilters/DHumanFiltersOverlay.vue";

export default {
  components: { DCardOverlayList, DHumanFiltersOverlay },
  name: "DCardActionOverlay",
  props: {
    showsEnterSection: {
      type: Boolean,
      default: false,
    },
    overlayList: {
      type: Object,
      required: false,
      default: null,
    },
    overlayTitle: {
      type: String,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hashId: {
      type: String,
      required: false,
      default: null,
    },
    apiBaseUrl: {
      type: Object,
      required: false,
      default: () => {},
    },
    cid: {
      type: String,
      required: true,
    },
    human_filters: {
      type: Object,
      default: () => null,
    },
    "company-source": {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showMenu: false,
      menuMouseEntered: false,
      canOpenOverlayList: false,
    };
  },
  computed: {
    overlayBtnLabel: {
      get() {
        return this.overlayList?.btn?.label ?? "View Details";
      },
    },
    overlayBtnIcon: {
      get() {
        return this.overlayList?.btn?.icon ?? "";
      },
    },
  },
  methods: {
    click(e) {
      if (e.target.getAttribute("data-prevent") === "true") {
        return;
      }

      this.showMenu = false;
      this.$emit("trackingEvent", { name: "click" });
      this.$emit("preview");
    },
    enterSectionClicked(e) {
      this.$emit("trackingEvent", { name: "click" });
      this.$emit("enterSection");
    },
    moreClicked(e) {
      this.$emit("trackingEvent", { name: "click" });
      this.showMenu = !this.showMenu;
    },
    mouseLeave(e) {
      if (this.canOpenOverlayList) {
        return;
      }

      if (!this.showMenu || this.menuMouseEntered) {
        this.$emit("mouseLeave");
      }
    },
    menuMouseLeave(e) {
      this.showMenu = false;
    },
    menuMouseEnter(e) {
      this.menuMouseEntered = true;
    },
    openOverlayList() {
      this.$emit("keepOverlay", !this.canOpenOverlayList);
      this.canOpenOverlayList = !this.canOpenOverlayList;
    },
  },
};
</script>

<style lang="scss">
.dcard-action-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.54) 0%,
    rgba(0, 0, 0, 0.54) 80%,
    rgba(0, 0, 0, 0.8) 100%
  );
  z-index: 10;
  cursor: zoom-in;
}
.bottom-toolbar {
  position: absolute;
  width: 100%;
  min-height: 40px;
  bottom: 12px;
  left: 0;
  align-items: flex-end;
}

.prevent {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.overlay {
  &-list {
    cursor: default;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    max-height: 0%;
    height: 90%;
    transition: 300ms ease max-height;

    &.opened {
      max-height: 90%;
    }
  }

  &-title {
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 0.285em;
    padding-right: calc(0.285em + 8px);
  }
}
</style>
